import { Dispatch, createContext, useContext } from 'react';
import { IAction } from '../../../store/modules/root/i-action';

export const DispatchContext = createContext<Dispatch<IAction>>(() => undefined);
export const useDispatch = (): Dispatch<IAction> => useContext<Dispatch<IAction>>(DispatchContext);
